import Vue from 'vue';

const globalMixin = {
    data() {
        return {
            trans: window.trans,
            lang: window.appLocale,
            userRole: window.userRole,
            userName: window.userName,
            jitsiDomain: window.jitsiDomain,
            jwt: window.jwt,
        };
    },
};

Vue.mixin(globalMixin);

export const goToRouteWithName = {
    methods: {
        async goToRouteWithName(name) {
            if (name === 'logout') {
                document.querySelector('#logout-form').submit();
                return;
            }
            try {
                await this.$router.push({ name, params: { lang: this.lang, user: this.userRole }})
            } catch (e) {}
        }
    }
};
